<template>
  <div class="container">
    <DataTable :value="ARCHIVED_ORDERS">
      <Column header="Order Datum">
        <template #body="slotProps">
          {{ orderDate(slotProps.data.data) }}
        </template>
      </Column>
      <Column field="id" header="Id" />
      <Column field="type" header="Typ" />
      <Column header="Kund">
        <template #body="slotProps">
          {{ customerName(slotProps.data.data)}}
        </template>
      </Column>
      <Column header="Leveransställe">
        <template #body="slotProps">
          {{ deliveryPlace(slotProps.data.data) }}
        </template>
      </Column>
      <Column header="Produkt">
        <template #body="slotProps">
          {{ productName(slotProps.data.data) }}
        </template>
      </Column>
      <Column header="Kvantitet">
        <template #body="slotProps">
          {{ quantityAmount(slotProps.data.data) }}
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderArchive',
  components: {
    DataTable,
    Column
  },
  async mounted () {
    await this.$store.dispatch('GET_CUSTOMERS')
    await this.$store.dispatch('GET_ARCHIVED_ORDERS')
  },
  computed: {
    ...mapGetters(['CUSTOMER_BY_ID', 'ARCHIVED_ORDERS'])
  },
  methods: {
    formatDate (theDate) {
      var formattedDate = moment(String(theDate)).format('YYYY-MM-DD')
      return formattedDate
    },
    customerName (data) {
      return this.CUSTOMER_BY_ID(data.kund).data.name
    },
    orderDate (data) {
      return data.DateLoadingEarly ? data.DateLoadingEarly : this.formatDate(data.createdAt)
    },
    deliveryPlace (data) {
      if (data.CustomerPlaces && Array.isArray(data.CustomerPlaces) === false) {
        return data.customerPlaceName
      } else if (data.DeliveryPlaceCity) {
        return data.DeliveryPlaceCity
      } else if (data.DeliveryPlaces) {
        return data.DeliveryPlaces
      } else if (data.CustomerPlacesDropDown) {
        return 'Okänd tillfälligt'
      }
      return 'Okänd för alltid'
    },
    productName (data) {
      if (data.ItemId) {
        return data.ItemId
      } else if (data.productId) {
        return data.productId
      }
      return 'Timkörning'
    },
    quantityAmount (data) {
      if (data.Quantity) {
        return parseFloat(data.Quantity).toFixed(2)
      }
      return ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Orders/OrderArchive.vue